import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import Skeleton from 'react-loading-skeleton';

import { filterErrorHandler } from "../../hoc/Shared/utility";
import DataTable from '../../components/Datatable/DataTable';
import Auxiliary from '../../hoc/Auxiliary/Auxiliary';
import Button from '../../components/Button/Button';

import * as actions from '../../store/ducks/memberRebate/actions';

class MemberRebateRolloverDetails extends Component {
    constructor(props) {
        super(props);
        this.state =
        {
            activePage: 1,
            limit: 10,
            totalRecords: 0,
            searchValue: '',
            order: '',

            data: [],
            memberDetails: [],
            loading: true,
            loadOnce: true,
        };
    }

    /* ============ component lifecycle [START] ============ */
    componentDidMount() {
        const listingArr = this.getFilterArray();
        this.props.funcGetRollover(listingArr);
    }

    shouldComponentUpdate(nextProps, nextState) {
        // console.log(nextProps.rolloverDetails);
        if (nextProps.rolloverDetails !== this.props.rolloverDetails && nextProps.rolloverDetails !== undefined) {
            if (nextProps.rolloverDetails.responseCode === 200 && nextProps.rolloverDetails.msgType === 'success') {
                this.setState({
                    memberDetails: nextProps.rolloverDetails.data.member,
                    data: nextProps.rolloverDetails.data.result.row,
                    totalRecords: nextProps.rolloverDetails.data.result.pagination.total_record,
                    loading: false,
                    loadOnce: false,
                });
            }
            else
            {
                this.setState({
                    activePage: 1,
                    memberDetails: [],
                    data: [],
                    totalRecords: 0,
                    loading: false,
                    loadOnce: false,
                }, () => 
                {
                    filterErrorHandler(nextProps.rolloverDetails.message); 
                });
            }
            Swal.close();
        }
        return true;
    }
    /* ============ component lifecycle [END] ============ */

    /* ============ function [START] ============ */
    refreshHandler = () => {
        // this.loadingHandler();
        const listingArr = this.getFilterArray();
        this.props.funcGetRollover(listingArr);
    }

    // loadingHandler = () =>
    // {
    //     Swal.fire({
    //         allowOutsideClick: false,
    //         allowEscapeKey: false,
    //         allowEnterKey: false,
    //         didOpen: () => {
    //             Swal.showLoading();
    //         }
    //     });
    // }

    getFilterArray = () => {
        // this.loadingHandler();
        const listingArr = {};
        const param = this.props.rolloverParam;

        listingArr.page = this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.search = this.state.searchValue;
        listingArr.order = JSON.stringify(this.state.order);
        listingArr.member_id = param.mid;
        listingArr.date = param.date;
        listingArr.id = param.id;
        this.setState({
            loading: true,
            data: [],
        });
        return listingArr;
    }

    noFormatter = (cell, row, rowIndex) => {
        let rowNumber = (this.state.totalRecords - rowIndex - ((this.state.activePage - 1) * this.state.limit));
        return <span>{rowNumber}</span>;
    }
    /* ============ function [END] ============ */

    /* ============ datatables function [START] ============ */
    onSort = (field, order) => {
        const orderArry = [{}];
        let orderSequence = (order === 'asc') ? true : false;

        orderArry[0]['id'] = field;
        orderArry[0]['desc'] = orderSequence;

        this.setState({ order: orderArry }, () => {
            this.refreshHandler();
        });
    }

    datatablesChangeHandler = (val, act) => {
        // console.log('datatablesChangeHandler :'+val + ' | '+act);
        this.setState({
            [act]: (act === 'searchValue') ? val.target.value : val
        }, () => {
            this.refreshHandler();
        });
    }
    /* ============ datatables function [END] ============ */

    render() {
        // console.log(this.props.rolloverParam);
        const { t } = this.props;
        let display = null;

        if (this.state.memberDetails) {
            let rsData = [];
            let date = this.props.rolloverParam.date.split(' ');

            const columns = [
                { text: t('global.no'), dataField: 'no', formatter: this.noFormatter, headerStyle: { width: '60px', textAlign: 'center' } },
                // {text: 'trans.id', dataField: 'id'},
                { text: t('member-rebate.game'), dataField: 'g_slug', sort: true, onSort: this.onSort },
                { text: t('member-rebate.game-type'), dataField: 'gt_slug', sort: true, onSort: this.onSort },
                { text: t('member-rebate.rebate-percentage'), dataField: 'percent', sort: true, onSort: this.onSort },
                { text: t('member-rebate.bet-amount'), dataField: 'bet_amount', sort: true, onSort: this.onSort },
                { text: t('member-rebate.turnover'), dataField: 'turnover', sort: true, onSort: this.onSort },
                { text: t('member-rebate.valid-turnover'), dataField: 'valid_turnover', sort: true, onSort: this.onSort },
                { text: t('member-rebate.rebate-amount'), dataField: 'rebate_amt', sort: true, onSort: this.onSort },
            ];

            // rsDetails = this.state.details[0];
            if (this.state.data) {
                // console.log('render :', this.state.data);
                rsData = this.state.data.map((val, idx) => {
                    const num_format = { maximumFractionDigits: 2, minimumFractionDigits: 2 };
                    return {
                        no: idx,
                        g_slug: t(`game.${val.g_slug}`),
                        gt_slug: t(`game-type.${val.gt_slug}`),
                        percent: new Intl.NumberFormat('en-US', num_format).format(val.percent),
                        bet_amount: new Intl.NumberFormat('en-US', num_format).format(val.bet_amount),
                        turnover: new Intl.NumberFormat('en-US', num_format).format(val.turnover),
                        valid_turnover: new Intl.NumberFormat('en-US', num_format).format(val.valid_turnover),
                        rebate_amt: new Intl.NumberFormat('en-US', num_format).format(val.rebate_amt),
                    };
                });
            }

            display =
                <Auxiliary>
                    <div className='breadcrumb-header'>
                        {/* <div className='my-auto'>
                            <div className='d-flex'>
                                <h4 className='content-title mb-0 my-auto text-muted mt-1 tx-13 ml-2 mb-0'>{t('member-rebate.title')}</h4>
                            </div>
                        </div> */}
                        <div className='d-flex'>
                            <div>
                                <div className='btn-group'>
                                    <Button typeButton='button' classValue='btn btn-back-outline' idValue='back' buttonName={<i className="angle fe fe-chevron-left"></i>} clicked={() => this.props.changePageHandler(this.props.rolloverParam.returnPage)} />
                                    <div className="member-name">
                                        <FontAwesomeIcon icon={faUser} /> {this.state.memberDetails.username}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row row-sm'>
                        <div className='col-lg-12 col-xl-12 col-md-12 col-sm-12'>
                            <div className='card box-shadow-0'>
                                <div className='card-header'>
                                    <h4 className='card-title mg-b-0'>{t('member-rebate.member-details')}</h4>
                                </div>
                                <div className="card-body pt-0">
                                    {(this.state.loading && this.state.loadOnce)
                                        ?
                                        <Skeleton count={3} />
                                        :
                                        <table className='table table-bordered table-hover'>
                                            <tbody>
                                                <tr>
                                                    <th>{t('member-rebate.date')}</th>
                                                    <td>{date[0]}</td>
                                                </tr>
                                                <tr>
                                                    <th>{t('member-rebate.member')}</th>
                                                    <td>{this.state.memberDetails.username}</td>
                                                </tr>
                                                <tr>
                                                    <th>{t('member-rebate.member-group')}</th>
                                                    <td>{t(`global.level.${this.props.currentUser.merchant_slug}.${this.state.memberDetails.group_id}`, this.state.memberDetails.group_name)}</td>
                                                </tr>
                                            </tbody>
                                        </table>}
                                    {this.state.loading
                                        ?
                                        <Skeleton count={1} />
                                        :
                                        <div className="mb-0 mt-3 justify-content-end d-flex my-xl-auto right-content">
                                            <Button typeButton='button' classValue='btn btn-blue' idValue='refresh' buttonName={t('global.refresh')} clicked={() => this.refreshHandler()} />
                                        </div>
                                    }
                                </div>
                            </div>


                            <div className='card box-shadow-0'>
                                <div className='card-header'>
                                    <h4 className='card-title mb-1'>{t(`member-rebate.${this.props.rolloverParam.returnPage}-details`)}</h4>
                                </div>
                                <div className='card-body'>
                                    <div className='table-responsive table-hover datatable'>
                                        <DataTable
                                            keyField='no'
                                            data={rsData}
                                            columns={columns}
                                            activePage={this.state.activePage}
                                            limit={this.state.limit}
                                            totalItems={this.state.totalRecords}
                                            paginationHandler={(val) => this.datatablesChangeHandler(val, 'activePage')}
                                            sizePerPageHandler={(val) => this.datatablesChangeHandler(val, 'limit')}
                                            searchChangeHandler={(val) => this.datatablesChangeHandler(val, 'searchValue')}
                                            searchValue={this.state.searchValue}
                                            classValue='dataTable table-bordered text-justify text-center'
                                            loading={this.state.loading}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Auxiliary>;
        }
        return (
            <Auxiliary>
                {display}
            </Auxiliary>
        );
    }
}

//Received the response from the redux calling the api response
const mapStateToProps = state => {
    return {
        rolloverDetails: state.memberRebate.rolloverDetails,
        currentUser: state.currentUser.data,
    }
};

//Using the redux calling api methods
const mapDispatchToProps = dispatch => {
    return {
        funcGetRollover: (mid, date, id) => dispatch(actions.getRollover(mid, date, id)),
    }
};

// Connect redux
export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces('translation')(MemberRebateRolloverDetails));